import React, { useEffect } from 'react';
import Logo from '../components/Animations/Logo';
import HelloLoading from '../components/Animations/HelloLoading';
import LoginForm from '../components/LandComponents/LoginForm';
import FormLayout from '../layouts/FormLayout';

function LoginPage(props: any) {

  useEffect(()=>{
    if(localStorage.getItem('Token')){props.history.push('/Home') }
  },[])

  return (
    <div className="App">
      <HelloLoading/>
        <FormLayout>
          <Logo/>
          <LoginForm/>
        </FormLayout>
    </div>
  );
}

export default LoginPage;